// ajax загрузка товарных листингов с заданной сортировкой и типом листинга
import {fetchData} from '@apress/apress-frontend-utils/utils/fetch-data/fetch-data.js';

app.modules.listingSwitcher = (function (self) {
  const _sortListButton = document.querySelector('.js-products-sort-button');
  const _switchСontainer = document.querySelector('.js-listing-switcher');
  const ACTIVE_SORT_CLASS = 'products-sort__item_active';
  let _action;
  let _actions;
  let _container;
  let _params;

  function _load() {
    _container.classList.add('loading');
    const _url = new URL(location.href);
    const _paramsSearch = {
      listing_style: _params.listingStyle,
      listing_sort: _params.listingSort,
    };
    Object.keys(_paramsSearch).forEach((key) => {
      if (_paramsSearch[key]) {
        _url.searchParams.append(key, _paramsSearch[key]);
      }
    });
    return fetchData({
      url: _url,
      options: {method: 'GET'},
      isXMLHttp: true,
      responseType: 'text',
    })
      .then((res) => res)
      .catch((error) => console.error(error));
  }

  function _updateQueryStringParam(key, value) {
    const baseUrl = [
      location.protocol,
      '//',
      location.host,
      location.pathname,
    ].join('');
    const urlQueryString = document.location.search;
    const newParam = key + '=' + value;
    let params = '?' + newParam;

    if (urlQueryString) {
      const keyRegex = new RegExp(key + '[^&]*');
      if (urlQueryString.match(keyRegex)) {
        params = urlQueryString.replace(keyRegex, newParam);
      } else {
        params = urlQueryString + '&' + newParam;
      }
    }
    window.history.replaceState({}, '', baseUrl + params);
  }

  function _switchParams() {
    if (_params.hasOwnProperty('listingSort')) {
      _sortListButton
        ? _updateQueryStringParam('listing_sort', _params.listingSort)
        : _switchListingSort();
    }
    if (_params.listingStyle) {
      _switchListingStyle();
    }
  }

  function _switchListingSort() {
    const actionData = _action.dataset;
    const sortType = actionData.sortResultType === 'asc' ? 'desc' : 'asc';
    _actions
      .querySelectorAll('.js-listing-switcher-item[data-listing-sort]')
      .forEach((el) => {
        el.dataset.sortResultType = '';
      });
    actionData.sortResultType = sortType;
    if (actionData.sortMethod) {
      actionData.listingSort = `${_params.sortMethod}_${sortType}`;
    }
    _updateQueryStringParam('listing_sort', _params.listingSort);
  }

  function _switchListingStyle() {
    if (_action.classList.contains('js-listing-switcher-mobile')) {
      const {listingStyle, notActiveListingStyle} = _action.dataset;
      _action.dataset.listingStyle = notActiveListingStyle;
      _action.dataset.notActiveListingStyle = listingStyle;
      _params.listingStyle = notActiveListingStyle;
      return;
    }
    _actions
      .querySelectorAll('.js-listing-switcher-item[data-listing-style]')
      .forEach((el) => {
        el.dataset.active = false;
      });
    _action.dataset.active = true;
  }

  function _toggleSortListView() {
    _sortListButton.classList.toggle('products-sort__button_show-list');
    _switchСontainer.classList.toggle('products-sort__list_show');
  }

  function _setButtonValue(element) {
    _sortListButton.textContent = element.firstElementChild.textContent;
    _sortListButton.dataset.sortType = element.dataset.listingSort;
  }

  function _toggleActiveSortType(element) {
    const activeSortType = document.querySelector(`.${ACTIVE_SORT_CLASS}`);
    activeSortType && activeSortType.classList.remove(ACTIVE_SORT_CLASS);
    element.classList.add(ACTIVE_SORT_CLASS);
  }

  function _changeSortType(element) {
    _toggleActiveSortType(element);
    _setButtonValue(element);
    _toggleSortListView();
  }

  function _handleClick(event) {
    _action = event.target.closest('.js-listing-switcher-item');

    if (_sortListButton && _action.classList.contains(ACTIVE_SORT_CLASS)) {
      return;
    }

    _sortListButton &&
      _action.closest('.products-sort__list') &&
      _changeSortType(_action);

    if (_action) {
      _actions = _action.closest('.js-listing-switcher');
      const listingContainer = _actions.dataset.listingContainer;
      _container = document.querySelector(listingContainer);
      _params = _action.dataset;

      if (_action.matches('.rating[data-sort-result-type="asc"]')) {
        return false;
      }

      _switchParams();
      _load().then((res) => {
        _container.classList.remove('loading');
        _container.innerHTML = res;

        document.dispatchEvent(new Event('spansToLinks'));
        $('.lazy').lazyload();
        app.modules.barmen.load();
        app.modules.catalogueProductSlider.load();

        document.dispatchEvent(new Event('reload:listingSwitcher'));
        document.dispatchEvent(new Event('mark:findMark'));
        document.dispatchEvent(new Event('unlock:seoLinks'));

        app.modules.favoriteProducts.update();
        app.config.isCompanyListing && app.modules.ajaxCompanyOffers.load();
      });
    }
  }

  function _listener() {
    document.addEventListener('click', (evt) => {
      if (!evt.target.closest('.js-listing-switcher')) {
        return;
      }
      _handleClick(evt);
    });

    _sortListButton &&
      _sortListButton.addEventListener('click', _toggleSortListView);
  }

  self.load = _listener;

  return self;
})(app.modules.listingSwitcher || {});
